import { render, staticRenderFns } from "./MomentPoints.vue?vue&type=template&id=4c8598f2&"
import script from "./MomentPoints.vue?vue&type=script&lang=js&"
export * from "./MomentPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports